import React, { SVGAttributes, useState } from "react";

interface Props extends SVGAttributes<SVGElement> {}

const IconSave: React.FC<Props> = (props) => {
  return (
    <svg viewBox="0 0 384 384" {...props}>
      <g>
        <g>
          <path
            d="M369.936,49.936l-35.888-35.888C325.056,5.056,312.848,0,300.112,0H288v96H64V0H32C14.32,0,0,14.32,0,32v320
c0,17.68,14.32,32,32,32h320c17.68,0,32-14.32,32-32V83.888C384,71.152,378.944,58.944,369.936,49.936z M320,320H64V158.944h256
V320z"
          />
        </g>
      </g>
      <g>
        <g>
          <rect x="208" y="0.002" width="48" height="64" />
        </g>
      </g>
      <g>
        <g>
          <rect x="96" y="192.002" width="192" height="32" />
        </g>
      </g>
      <g>
        <g>
          <rect x="96" y="256.002" width="192" height="32" />
        </g>
      </g>
    </svg>
  );
};

export default IconSave;
